<script lang="ts">
  import { partyAbbr } from '../../lib/race';
  let { party, color = 'other' }: { party: string | null; color?: string } = $props();
  const abbr = $derived(partyAbbr(party));
</script>

{#if abbr}<span class="pb" style="--c:var(--c-{color === 'dem' || color === 'rep' ? color : 'other'})" title={party ?? ''}>{abbr}</span>{/if}

<style>
  /* darkened toward black so white text clears 4.5:1 in both themes (the gray 'other' badge too) */
  .pb { display: inline-grid; place-items: center; min-width: 20px; height: 20px; padding: 0 5px; border-radius: 6px; background: color-mix(in oklab, var(--c) 62%, #000); color: #fff; font: 700 0.68rem/1 var(--font); flex: none; }
</style>
